import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Reveal } from './Reveal';
import { LANDING_ANCHORS, LANDING_FAQ } from '../../domain/landingContent';

const TRANS = 'transition-all duration-500 ease-[cubic-bezier(0.32,0.72,0,1)]';

/** FAQ acordeão + JSON-LD FAQPage para SEO. */
export function LandingFaq() {
  const [aberto, setAberto] = useState<number | null>(0);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: LANDING_FAQ.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: { '@type': 'Answer', text: a },
    })),
  };

  return (
    <section
      id={LANDING_ANCHORS.faq}
      className="mx-auto max-w-3xl scroll-mt-24 px-4 py-24 sm:px-6 sm:py-32"
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Reveal className="text-center">
        <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Perguntas frequentes
        </h2>
      </Reveal>

      <div className="mt-10 space-y-3">
        {LANDING_FAQ.map(({ q, a }, i) => {
          const isAberto = aberto === i;
          return (
            <Reveal key={q} delay={i * 0.03}>
              <div
                className={`${TRANS} overflow-hidden rounded-3xl border bg-white/[0.03] ${
                  isAberto ? 'border-orange-500/25' : 'border-white/[0.06]'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setAberto(isAberto ? null : i)}
                  aria-expanded={isAberto}
                  className="flex min-h-11 w-full items-center justify-between gap-3 px-5 py-4 text-left text-sm font-semibold text-white transition-colors hover:bg-white/[0.03] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/40 motion-reduce:transition-none sm:px-6"
                >
                  <span className="min-w-0 break-words">{q}</span>
                  <ChevronDown
                    className={`${TRANS} h-4 w-4 shrink-0 text-slate-400 ${
                      isAberto ? 'rotate-180 text-orange-400' : ''
                    }`}
                  />
                </button>
                {isAberto && (
                  <p className="animate-fade-in px-5 pb-5 text-sm leading-relaxed text-slate-400 sm:px-6">
                    {a}
                  </p>
                )}
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
